/**
 * Pure flag resolution — a leaf module with NO React / Supabase / app-mode imports, so
 * the loading-gate semantics are unit-testable in isolation (the rest of the feature-flags
 * module pulls in React Query, the Supabase client, and auth).
 *
 * `defaultValue` is returned while the flag set is still loading, in mock mode, or before
 * the RPC has succeeded — so a KILL-SWITCH on a shipped feature defaults `true` (visible
 * unless explicitly killed) and a TESTER-GATED feature defaults `false` (hidden unless
 * explicitly granted): "still loading" must resolve to the safe optimistic value, never a
 * hard block.
 */
export function resolveFlag(args: {
  key: string;
  defaultValue: boolean;
  isMock: boolean;
  isSuccess: boolean;
  enabledKeys: string[] | undefined;
}): boolean {
  const { key, defaultValue, isMock, isSuccess, enabledKeys } = args;
  if (isMock || !isSuccess || !enabledKeys) return defaultValue;
  return enabledKeys.includes(key);
}
